import DeadlineControl from "components/deadline-control";
import { IconTrash } from "components/icons/icn-index.icon";
import OptionGroup from "components/option-group";
import { SelectBox } from "components/uikit-adapter/index";
import PropTypes from 'prop-types'
import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import intl from "react-intl-universal";
import { withRouter } from "react-router-dom";
import { DATA_FORMAT_TYPES, getDataFormat } from "utils/format-date";
import SuggestionsListHeader from "./../suggestions-list-header";
import StyledSuggestionsListItem from "./suggestions-list-item.styled";

import './suggestions-list-item.css'
import ButtonIcon from "components/button-icon";
import IconCancelWhite from "components/icons/icn-cancel-white.icon";
import IconSaveBlue from "components/icons/icn-save-blue.icon";
import Input from "components/input";
import InputNumber from 'components/input-number';
import TextArea from "components/textarea";
import { Incoterms } from "models/incoterm/incoterms";
import { getDocumentTypeOptions } from 'pages/stocks-detail/utils'
import { validatesArrayHasValue } from "utils/custom-functions";
import { convertTransitTimeToDaysByFlag } from "utils/date";
import { formatHourTimeOrDefault } from "utils/delivery-time";
import { getDoorObjectByName, getDoorsOptions, isDoorsDisabled } from "utils/doors";
import { formatNumber } from "utils/format";
import {
  useRequirementCode,
  usesJustificationValidationAcceptingSuggestion,
  usesTransferOrder,
} from "utils/validations-general-settings";
import { searchPorts } from '../../../pages/stocks-detail/stocks-detail.service'
import { ButtonLoadCompositionPlus } from "../../button-load-composition-plus";
import LocationFields from "../location-fields";
import { mapperItemDataForLoadCompositionModal, shouldDisableTransferInputs } from "./utils";

const ORIGEM_XADREZ = { value: 1 }
const ORIGEM_UNIDADES = { value: 2 }
const TIPO_UNIDADE_FORNECEDORA = { value: 2 }
const SUGESTAO_GERADA = 1
const SUGESTAO_MANUAL = 3
const SUGESTAO_ALTERADA = 4
const SUGESTAO_AGUARDANDO_COMPOSICAO_CARGA = 5
const SUGESTAO_EM_RENEGOCIACAO_EMERGENCIAL = 6
const PERIODICIDADE_DIARIA = 2;
const isUnidadeFornecedora = (tipoUnidade) => tipoUnidade === TIPO_UNIDADE_FORNECEDORA.value

class SuggestionsListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      optionsTypesSuppliers: {
        id: 0,
        optionOne: {
          name: intl.get("stocks.suggestionsListItem.chess"),
          value: 1,
          isChecked: true,
        },
        optionTwo: {
          name: intl.get("stocks.suggestionsListItem.transferUnits"),
          value: 2,
          isChecked: false,
          hideOption: !usesTransferOrder(),
        },
      },
      fornecedores: [],
      ports: { loading: [], discharge: [] },
      origem: 1,
      transiTimeErroMessage: false,
      incotermOptions: Incoterms.filter((x) => x.Key !== 0),
      tipoUnidade: 0,
      transitTime: props.item.TransitTime,
    };
  }

  componentDidMount() {
    const { item } = this.props;

    const suppliers = this.loadSuppliersListAndOrigin(item.OrigemFornecedor, item.IdMaterial, item);
    const hasInternationalSupplier = suppliers.find((x) => x.InternationalSupplierGroupId > 0);

    if (hasInternationalSupplier) this.loadPorts();

  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.props) !== JSON.stringify(nextProps) ||
      JSON.stringify(this.state) !== JSON.stringify(nextState)
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.checked !== undefined && prevProps.checked !== this.props.checked) {
      this.setState({
        checked: this.props.checked,
      });
    }

    if (prevProps.unCheckItem !== this.props.unCheckItem && this.props.unCheckItem) {
      this.setState({
        checked: false,
      });
    }

  }

  checkItem = (event) => {
    this.setState(
      (prevState) => ({ checked: !prevState.checked }),
      () => {
        this.props.checkItem(this.props.item, this.state.checked);
      }
    );
  };

  expandItems = (eventTarget) => {
    this.props.expandItem(
      eventTarget,
      this.props.item,
      this.props.item.itemsExpanded,
      false,
      false,
      this.props.itemIndex
    );
  };

  changeMaterial = (prop, idMaterial, item) => {
    item.IdMaterial = idMaterial;

    const _suppliers = this.loadSuppliersListAndOrigin(this.state.origem, idMaterial, item);
    item.IdFornecedor = _suppliers.length > 0 ? _suppliers[0].Id : null;
    item.PickUpLocation = null;
    item.DeliveryLocation = null;
    this.props.changeValueSugestao(prop, idMaterial, item);
    this.changeFornecedor(item.IdFornecedor, item);
  };

  changeFornecedor = (idFornecedor, item) => {
    const material = item.Materiais.find((m) => m.Id == item.IdMaterial);
    const fornecedor = material.Fornecedores.find((f) => f.Id == idFornecedor);

    if (item.IdFornecedor !== idFornecedor) {
      item.PickUpLocation = null;
      item.DeliveryLocation = null;
    }

    this.props.changeValueSugestao("IdFornecedor", idFornecedor, item);

    this.setState({
      tipoUnidade: fornecedor ? fornecedor.TipoUnidade : 0,
      transitTime: fornecedor ? fornecedor.TransitTime : 2,
    });
  };

  selectOptionTypeSuppliers = (origem, idMaterial, item) => {
    item.GrupoCompradores = null;
    item.OrganizacaoCompras = null;
    item.CodigoImposto = null;
    item.PickUpLocation = null;
    item.DeliveryLocation = null;

    const _suppliers = this.loadSuppliersListAndOrigin(origem, idMaterial, item);
    let idFornecedor = _suppliers.length > 0 ? _suppliers[0].Id : null;
    this.changeFornecedor(idFornecedor, item);
  };

  loadSuppliersListAndOrigin = (origem, idMaterial, item) => {
    const { optionsTypesSuppliers } = this.state;
    const material = item.Materiais.find((m) => m.Id === idMaterial);

    let _optionsTypesSuppliers = optionsTypesSuppliers;
    _optionsTypesSuppliers.id = item.Id;

    let fornecedores = [];

    if (origem == ORIGEM_UNIDADES.value) {
      fornecedores = material.Fornecedores.filter((f) => f.Origem == ORIGEM_UNIDADES.value);
      _optionsTypesSuppliers.optionOne.isChecked = false;
      _optionsTypesSuppliers.optionTwo.isChecked = true;
    } else {
      fornecedores = material.Fornecedores.filter((f) => f.Origem == ORIGEM_XADREZ.value);
      _optionsTypesSuppliers.optionOne.isChecked = true;
      _optionsTypesSuppliers.optionTwo.isChecked = false;
    }

    this.setState({
      fornecedores,
      origem,
      optionsTypesSuppliers: _optionsTypesSuppliers,
    });
    return fornecedores;
  };

  loadPorts = async () => {
    try {
      const ports = await searchPorts();
      const formattedPorts = ports.map((port) => ({
        Id: port.Id,
        Descricao: `${port.Code} - ${port.Name}`,
      }));

      this.setState({
        ports: {
          loading: [
            { Id: 0, Descricao: intl.get("stocks.suggestionsListItem.defaultPortOfLoading") },
            ...formattedPorts,
          ],
          discharge: [
            { Id: 0, Descricao: intl.get("stocks.suggestionsListItem.defaultPortOfDischarge") },
            ...formattedPorts,
          ],
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  salvarSugestao(sugestao) {
    if (
      this.state.origem == ORIGEM_UNIDADES.value &&
      (!sugestao.GrupoCompradores || !sugestao.OrganizacaoCompras)
    )
      this.props.handleFeedback(intl.get("stocks.timeline.feedback.transferInformationMandatory"));
    else if (
      (sugestao.IntStatus === SUGESTAO_MANUAL || sugestao.itemAlterado) &&
      !sugestao.TipoJustificativaSugestaoManual &&
      usesJustificationValidationAcceptingSuggestion()
    )
      this.props.handleFeedback(intl.get("stocks.timeline.feedback.providerJustification"));
    else {
      this.props.salvarSugestao({
        ...sugestao,
      });
    }
  }

  addRowOriginSaz = (item, optionsTypesSuppliers) => {
    return (
      <Row>
        <Col xs={12}>
          <OptionGroup
            title={intl.get("stocks.suggestionsListItem.origin")}
            handleSelect={(event) =>
              this.selectOptionTypeSuppliers(event.currentTarget.value, item.IdMaterial, item)
            }
            options={optionsTypesSuppliers}
            className="optionGroup-origin"
          />
        </Col>
      </Row>
    );
  };

  addColDeliveryHour = (item) => {
    return (
      <Col xs={6}>
        <Input
          label={intl.get("commons.deliveryTime")}
          name="HoraEntrega"
          className="input-hora-entrega"
          htmlType="time"
          value={item.HoraEntrega}
          onChange={(event) =>
            this.props.changeHoraEntrega("HoraEntrega", event.target.value, item)
          }
        />
      </Col>
    );
  };

  addColRequirementCode = (item) => {
    return (
      useRequirementCode() && (
        <Col xs={6}>
          <Input
            label={intl.get("orders.requirementCode")}
            name="requirementCode"
            value={item.RequirementCode}
            onChange={(event) =>
              this.props.changeValueSugestao("RequirementCode", event.target.value, item)
            }
            maxLength="40"
          />
        </Col>
      )
    );
  };

  addRowJustificationSuggestionManual = (item, listaJustificativasSugestaoManual) => {
    return (
      (!item.IntStatus ||
        item.IntStatus === SUGESTAO_MANUAL ||
        ((item.IntStatus === SUGESTAO_ALTERADA ||
          item.IntStatus === SUGESTAO_AGUARDANDO_COMPOSICAO_CARGA ||
          item.IntStatus === SUGESTAO_EM_RENEGOCIACAO_EMERGENCIAL) &&
          (item.TipoJustificativaSugestaoManual || item.itemAlterado)) ||
        (item.IntStatus === SUGESTAO_GERADA && item.itemAlterado)) &&
      usesJustificationValidationAcceptingSuggestion() && (
        <Row>
          <Col xs={12}>
            <SelectBox
              name="tipoJustificativaSugestaoManual"
              label={intl.get("stocks.suggestionsListItem.justificationChangingSuggestion")}
              placeholder={intl.get("stocks.suggestionsListItem.justification")}
              value={item.TipoJustificativaSugestaoManual}
              options={listaJustificativasSugestaoManual}
              onChange={(value) =>
                this.props.changeValueSugestao("TipoJustificativaSugestaoManual", value.Key, item)
              }
              valueKey="Key"
              labelKey="Value"
              className="select-justificativa-sugestao"
              searchable
              openOnFocus
            />
          </Col>
        </Row>
      )
    );
  };

  suggestionsListHeaderIsChecked = (checked, item) =>
    checked &&
    (item.Coleta ?? item.SuggestionCollectDate) &&
    (item.DataEntregaDe ?? item.SuggestionDeliveryDate) &&
    !item.naoSalvo;

  suggestionsListHeaderEnableCheckedValidate = (item) =>
    item.naoSalvo ||
    !(item.Coleta ?? item.SuggestionCollectDate) ||
    !(item.DataEntregaDe ?? item.SuggestionDeliveryDate);

  suggestionsListHeaderCheckboxDisabled = (item) =>
    this.suggestionsListHeaderEnableCheckedValidate(item);

  getClassNameWrapper = () => (this.props.item.itemsExpanded ? "item-expanded" : "");

  showDocumentTypesSelectBox = () => validatesArrayHasValue(this.props.documentTypes);

  validateColumnsWhenHourlyPlan = (isHourlyPlan) => (isHourlyPlan ? 1 : 2);

  render() {
    const {
      listaJustificativasSugestaoManual,
      excluirSugestao,
      item,
      highlighted,
      itemDimmed,
      showBtnCancel,
      linhaProducaoCentro,
      documentTypes,
      doors,
      isHourlyPlan,
    } = this.props;

    const {
      checked,
      optionsTypesSuppliers,
      fornecedores,
      ports,
      origem,
      incotermOptions,
      tipoUnidade,
      transitTime,
    } = this.state;

    const selectedSupplier = fornecedores.find((supplier) => supplier.Id === item.IdFornecedor);
    const internationalSupplier = selectedSupplier
      ? selectedSupplier.InternationalSupplierGroupId > 0
      : false;

    return (
      <StyledSuggestionsListItem className={this.getClassNameWrapper()}>
        <SuggestionsListHeader
          isItem
          hasIcon
          isOrder={false}
          itemsExpanded={item.itemsExpanded}
          checked={this.suggestionsListHeaderIsChecked(checked, item)}
                  enableCheck={this.suggestionsListHeaderCheckboxDisabled(item)}
          idCheckbox={item.Id}
          suggestionId={item.Id}
          hasSnapshot={item.HasSnapshot}
          checkItem={this.checkItem}
          highlighted={highlighted}
          itemDimmed={itemDimmed}
          expandAllItems={this.expandItems}
        >
          <Row middle="xs">
            <Col xs={2}>
              <div title={item.Status} className="header-item">
                {item.StatusSigla}
              </div>
            </Col>
            <Col xs={2}>
              <div title={item.TipoDescricao} className="header-item">
                {item.Tipo}
              </div>
            </Col>
            <Col xs={this.validateColumnsWhenHourlyPlan(isHourlyPlan)}>
              <div
                title={getDataFormat(item.Coleta, DATA_FORMAT_TYPES.WITH_YEAR)}
                className="header-item"
              >
                {getDataFormat(item.Coleta, DATA_FORMAT_TYPES.WITHOUT_YEAR)}
              </div>
            </Col>
            <Col xs={this.validateColumnsWhenHourlyPlan(isHourlyPlan)}>
              <div
                title={getDataFormat(item.DataEntregaDe, DATA_FORMAT_TYPES.WITH_YEAR)}
                className="header-item"
              >
                {getDataFormat(item.DataEntregaDe, DATA_FORMAT_TYPES.WITHOUT_YEAR)}
              </div>
            </Col>
            {isHourlyPlan && (
              <Col xs={2}>
                <div className="header-item">{formatHourTimeOrDefault(item.HoraEntrega)}</div>
              </Col>
            )}
            <Col xs={2}>
              <div className="header-item">{formatNumber(item.Total)}</div>
            </Col>
            <Col xs={2}>
              <div className="header-item">{item.UnidadeMedida}</div>
            </Col>
          </Row>
        </SuggestionsListHeader>
        <div
          className="table-list-item-body"
          style={{ display: item.itemsExpanded ? "block" : "none" }}
        >
          <Row>
            <Col xs={12}>
              <SelectBox
                name="material"
                label={intl.get("commons.material")}
                placeholder={intl.get("commons.material")}
                value={item.IdMaterial}
                options={item.Materiais}
                onChange={(value) => this.changeMaterial("IdMaterial", value.Id, item)}
                valueKey="Id"
                labelKey="MaterialPesquisa"
                searchable
                openOnFocus
              />
            </Col>
          </Row>

          {this.addRowOriginSaz(item, optionsTypesSuppliers)}

          <Row>
            <Col xs={12}>
              <SelectBox
                name="fornecedor"
                label={intl.get("commons.supplier")}
                placeholder={intl.get("stocks.suggestionsListItem.supplier")}
                value={item.IdFornecedor}
                options={fornecedores}
                onChange={(value) => this.changeFornecedor(value.Id, item)}
                valueKey="Id"
                labelKey="Descricao"
                searchable
                openOnFocus
              />
            </Col>
          </Row>

          <LocationFields
            item={item}
            supplier={selectedSupplier}
            deliveryLocations={this.props.deliveryLocations}
            destination={this.props.destination}
            labeledFamilyCenterId={this.props.idFamiliaRotuladaCentro}
            activeMaterialId={this.props.idMaterialAtivo}
            alwaysShow
            onChange={(name, value) => this.props.changeValueSugestao(name, value, item)}
          />

          <Row>
            <Col xs={12}>
              <DeadlineControl
                TituloColeta={intl.get("stocks.suggestionsListItem.collect")}
                TituloEntrega={intl.get("stocks.suggestionsListItem.issue")}
                TransitTime={convertTransitTimeToDaysByFlag(transitTime, isHourlyPlan)}
                OnChange={(coleta, entrega) =>
                  this.props.changeValueDeadline(coleta, entrega, item)
                }
                Coleta={item.Coleta}
                DataEntregaDe={item.DataEntregaDe}
                Identificador={`sugestao-` + item.Id}
              />
            </Col>
          </Row>

          {internationalSupplier && item.Periodicidade == PERIODICIDADE_DIARIA && (
            <Row>
              <Col xs={6}>
                <SelectBox
                  name="PortOfLoading"
                  label={intl.get("commons.portOfLoading")}
                  placeholder={intl.get("stocks.suggestionsListItem.portOfLoading")}
                  value={item.PortOfLoadingId ?? 0}
                  options={ports.loading}
                  onChange={(value) =>
                    this.props.changeValueSugestao(
                      "PortOfLoadingId",
                      value.Id ? value.Id : null,
                      item
                    )
                  }
                  valueKey="Id"
                  labelKey="Descricao"
                  searchable
                  openOnFocus
                />
              </Col>

              <Col xs={6}>
                <SelectBox
                  name="PortOfDischarge"
                  label={intl.get("commons.portOfDischarge")}
                  placeholder={intl.get("stocks.suggestionsListItem.portOfDischarge")}
                  value={item.PortOfDischargeId ?? 0}
                  options={ports.discharge}
                  onChange={(value) =>
                    this.props.changeValueSugestao(
                      "PortOfDischargeId",
                      value.Id ? value.Id : null,
                      item
                    )
                  }
                  valueKey="Id"
                  labelKey="Descricao"
                  searchable
                  openOnFocus
                />
              </Col>
            </Row>
          )}

          <Row>
            {this.addColDeliveryHour(item)}

            {this.addColRequirementCode(item)}

            <Col xs={this.showDocumentTypesSelectBox() ? 6 : 12}>
              <SelectBox
                required
                label={intl.get("stocks.suggestionsListItem.incoterm")}
                placeholder={intl.get("stocks.suggestionsListItem.incoterm")}
                name="Incoterm"
                value={item.ResponsavelEntrega}
                valueKey="Key"
                labelKey="Value"
                onChange={(value) =>
                  this.props.changeValueSugestao("ResponsavelEntrega", value.Key, item)
                }
                openOnFocus={true}
                options={incotermOptions}
                width="100%"
              />
            </Col>

            {this.showDocumentTypesSelectBox() && (
              <Col xs={6}>
                <SelectBox
                  required
                  label={intl.get("stocks.suggestionsListItem.documentType")}
                  placeholder={intl.get("stocks.suggestionsListItem.documentType")}
                  name="DocumentType"
                  value={item.DocumentType}
                  valueKey="DocumentTypeEnumValue"
                  labelKey="DocumentTypeEnumDescription"
                  onChange={(value) =>
                    this.props.changeValueSugestao(
                      "DocumentType",
                      value.DocumentTypeEnumValue,
                      item
                    )
                  }
                  openOnFocus={true}
                  options={getDocumentTypeOptions(
                    documentTypes,
                    item.Materiais,
                    item.IdMaterial,
                    item.IdFornecedor
                  )}
                  width="100%"
                />
              </Col>
            )}
          </Row>

          {item.ShowTransitTimeDateWarn && (
            <Row>
              <Col>
                <label className="transit-time-date-warn">
                  {intl.get("stocks.suggestionsListItem.transitTime")}
                </label>
              </Col>
            </Row>
          )}

          <Row>
            <Col xs={3}>
              <Input
                label={intl.get("stocks.suggestionsListItem.lotSize")}
                name="tamLote"
                htmlType="text"
                value={formatNumber(item.QuantidadeLote)}
                disabled
              />
            </Col>
            <Col xs={3}>
              <InputNumber
                value={item.Quantidade}
                onChange={(value) => this.props.changeValueSugestao("Quantidade", value, item)}
                className="input-received-quantity"
                label={intl.get("stocks.suggestionsListItem.quantity")}
                type="default"
                allowDecimals
                decimalsLimit={3}
              />
            </Col>
            <Col xs={3}>
              <InputNumber
                type="default"
                label={intl.get("stocks.suggestionsListItem.cars")}
                name="carros"
                value={item.QuantidadeCarros}
                allowDecimals
                decimalsLimit={3}
                disabled
              />
            </Col>
            <Col xs={3}>
              <InputNumber
                type="default"
                label={intl.get("stocks.suggestionsListItem.total")}
                name="total"
                value={item.Total}
                onChange={(value) => this.props.changeValueSugestao("Total", value, item)}
                allowDecimals
                decimalsLimit={3}
              />
            </Col>
            <React.Fragment>
              <Col xs={4}>
                <SelectBox
                  name="Door"
                  label={intl.get("commons.door")}
                  value={getDoorObjectByName(doors, item.PortaWMS)}
                  valueKey="Id"
                  labelKey="Name"
                  options={getDoorsOptions(doors)}
                  onChange={(event) => this.props.changeValueSugestao("PortaWMS", event.Name, item)}
                  className="input-door-wms input"
                  disabled={isDoorsDisabled(doors, item.PortaWMS)}
                />
              </Col>
              <Col xs={4}>
                <SelectBox
                  name="ProductionLine"
                  label={intl.get("orders.productionLine")}
                  placeholder={intl.get("orders.productionLine")}
                  valueKey="key"
                  labelKey="productionLine"
                  value={
                    item.LinhaDeProducao ? { productionLine: item.LinhaDeProducao } : undefined
                  }
                  options={linhaProducaoCentro}
                  onChange={(event) =>
                    this.props.changeValueSugestao("LinhaDeProducao", event?.productionLine, item)
                  }
                  className="selectBoxProductionLine input"
                  clearable
                />
              </Col>
              <Col xs={4}>
                <Input
                  label={intl.get("orders.comments")}
                  name="comments"
                  value={item.Comentarios}
                  onChange={(event) =>
                    this.props.changeValueSugestao("Comentarios", event.target.value, item)
                  }
                  maxLength="40"
                  className="textAreaComments"
                />
              </Col>
            </React.Fragment>
          </Row>

          {(isUnidadeFornecedora(tipoUnidade) || origem == ORIGEM_UNIDADES.value) && (
            <div>
              <label className="label-style">
                {intl.get("stocks.suggestionsListItem.driveTransferInformation")}
              </label>
              <div className="container">
                <Row>
                  <Col xs={4}>
                    <Input
                      label={intl.get("stocks.suggestionsListItem.purchasingOrganization")}
                      name="organizacaoCompras"
                      htmlType="text"
                      value={
                        origem == ORIGEM_UNIDADES.value
                          ? item.OrganizacaoCompras
                          : selectedSupplier?.OrganizacaoCompras
                      }
                      onChange={(event) =>
                        this.props.changeValueSugestao(
                          "OrganizacaoCompras",
                          event.target.value.toUpperCase(),
                          item
                        )
                      }
                      maxLength={4}
                      disabled={shouldDisableTransferInputs(origem, tipoUnidade)}
                    />
                  </Col>
                  <Col xs={4}>
                    <Input
                      label={intl.get("stocks.suggestionsListItem.buyerGroup")}
                      name="grupoCompradores"
                      value={
                        origem == ORIGEM_UNIDADES.value
                          ? item.GrupoCompradores
                          : selectedSupplier?.GrupoCompradores
                      }
                      onChange={(event) =>
                        this.props.changeValueSugestao(
                          "GrupoCompradores",
                          event.target.value.toUpperCase(),
                          item
                        )
                      }
                      maxLength={3}
                      disabled={shouldDisableTransferInputs(origem, tipoUnidade)}
                    />
                  </Col>
                  <Col xs={4}>
                    <Input
                      label={intl.get("stocks.suggestionsListItem.taxCode")}
                      name="codigoImposto"
                      value={
                        origem == ORIGEM_UNIDADES.value
                          ? item.CodigoImposto
                          : selectedSupplier?.CodigoImposto
                      }
                      onChange={(event) =>
                        this.props.changeValueSugestao(
                          "CodigoImposto",
                          event.target.value.toUpperCase(),
                          item
                        )
                      }
                      maxLength={5}
                      disabled={shouldDisableTransferInputs(origem, tipoUnidade)}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          )}

          {this.addRowJustificationSuggestionManual(item, listaJustificativasSugestaoManual)}

          <Row>
            <Col xs={12}>
              <TextArea
                label={intl.get("stocks.suggestionsListItem.observation")}
                name="observacao"
                value={item.Observacao || ""}
                onChange={(event) =>
                  this.props.changeValueSugestao("Observacao", event.target.value, item)
                }
              />
            </Col>
          </Row>

          <Row end="xs">
            <Col xs={12} className="table-list-footer">
              <div>
                <ButtonLoadCompositionPlus
                  isFullTruckLoad={item.Total === item.QuebraEntrega}
                  item={mapperItemDataForLoadCompositionModal(
                    item,
                    this.props.idUnidadeNegocio,
                    false,
                    item.IdFornecedor
                  )}
                  history={this.props.history}
                  hidden={this.suggestionsListHeaderEnableCheckedValidate(item)}
                />
              </div>
              <div title={intl.get("stocks.suggestionsListItem.deleteSuggestion")}>
                <ButtonIcon
                  buttonIcon={
                    showBtnCancel ? (
                      <IconCancelWhite />
                    ) : (
                      <IconTrash color={"var(--color-contrast-white)"} />
                    )
                  }
                  buttonType="danger"
                  onClick={() => excluirSugestao(item)}
                  className="btn-delete-suggestion-item"
                  style={{ width: "50px" }}
                />
              </div>
              <div
                title={intl.get("stocks.suggestionsListItem.saveSuggestion")}
                data-testid="wrapper-btn-save-suggestion-item"
              >
                <ButtonIcon
                  buttonIcon={<IconSaveBlue />}
                  buttonType="secondary"
                  onClick={() => this.salvarSugestao(item)}
                  style={{ width: "50px" }}
                />
              </div>
            </Col>
          </Row>
        </div>
      </StyledSuggestionsListItem>
    );
  }
}

SuggestionsListItem.propTypes = {
  item: PropTypes.object.isRequired,
  checkItem: PropTypes.func,
  expandItem: PropTypes.func,
  checked: PropTypes.bool,
  unCheckItem: PropTypes.bool,
  salvarSugestao: PropTypes.func,
  excluirSugestao: PropTypes.func,
  changeValueSugestao: PropTypes.func,
  obterListaJustificativasSugestaoManual: PropTypes.func,
  changeValueDeadline: PropTypes.func,
  materiais: PropTypes.array,
  highlighted: PropTypes.bool,
  itemDimmed: PropTypes.bool,
  itemIndex: PropTypes.number,
  handleFeedback: PropTypes.func,
  changeHoraEntrega: PropTypes.func,
  documentTypes: PropTypes.array,
  listaJustificativasSugestaoManual: PropTypes.array,
  showBtnCancel: PropTypes.bool,
  linhaProducaoCentro: PropTypes.array,
  doors: PropTypes.any,
  isHourlyPlan: PropTypes.bool,
  idUnidadeNegocio: PropTypes.string,
  history: PropTypes.any,
  deliveryLocations: PropTypes.array,
  destination: PropTypes.object,
  idFamiliaRotuladaCentro: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idMaterialAtivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default withRouter(SuggestionsListItem)
